import { defineStore } from 'pinia'

import * as sellRequestSourceApi from '../services/api/sell-request-source'

export interface ISellRequestSourceData {
  id: number
  name: string
  color: string
}

export const useSellRequestSourceStore = defineStore('SellRequestSource', {
  state: () => ({
    sellRequestSources: [] as ISellRequestSourceData[],
  }),
  actions: {
    setSellRequestSources(data: ISellRequestSourceData[]) {
      this.sellRequestSources = data
    },
    setSellRequestSource(data: ISellRequestSourceData) {
      const source = this.sellRequestSources.find((s: ISellRequestSourceData) => s.id === data.id)
      if (source) {
        Object.assign(source, data)
      }
    },
    addSellRequestSource(data: ISellRequestSourceData) {
      this.sellRequestSources.push(data)
    },
    async getSellRequestSourceDetail(id: number) {
      try {
        const { data } = await sellRequestSourceApi.get(id)
        this.setSellRequestSource(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async updateSellRequestSource(id: number, payload: any) {
      try {
        const { data } = await sellRequestSourceApi.update(id, payload)
        this.setSellRequestSource(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async createSellRequestSource(payload: any) {
      try {
        const { data } = await sellRequestSourceApi.create(payload)
        this.addSellRequestSource(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listSellRequestSources() {
      try {
        const { data } = await sellRequestSourceApi.list()
        this.setSellRequestSources(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
  },
})
